import {
  Autocomplete,
  TextField,
  Chip,
  Box,
  IconButton,
  InputAdornment,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useState } from "react";

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export default function EmailInput({ label, value = [], onChange }) {
  const setValue = onChange || (() => {});
  if (typeof value == "string") {
    value = value
      .replaceAll(";", ",")
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);
  }

  const handleCopy = () => {
    const text = value.join(", ") + ",";
    navigator.clipboard.writeText(text);
  };

  return (
    <Autocomplete
      multiple
      freeSolo
      options={[]}
      value={value}
      onChange={(event, newValue) => {
        setValue((v) => {
          if (v.length < newValue.length && newValue.length) {
            let lastItem = newValue[newValue.length - 1];

            if (lastItem.includes(",") || lastItem.includes(";")) {
              lastItem = lastItem.replaceAll(",", ";");

              const emails = lastItem
                .split(";")
                .map((v) => v.trim())
                .filter(Boolean)
                .filter(isValidEmail);

              newValue = [...newValue.slice(0, newValue.length - 1), ...emails];
            } else if (!isValidEmail(lastItem)) return v;
          }

          const list = {};
          newValue.forEach((v) => {
            list[v] = true;
          });

          return Object.keys(list);
        });
      }}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "start",
      }}
      renderTags={(value, getTagProps) => (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 0,
            p: 1,
            pb: 0,
            width: "100%",
          }}
        >
          {value.map((option, index) => (
            <Chip
              key={index}
              variant="outlined"
              label={option}
              {...getTagProps({ index })}
            />
          ))}
        </Box>
      )}
      disableClearable
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="Type email and press Enter"
          multiline
          inputProps={{
            ...params.inputProps,
            onChange: (...p) => {
              let item = p[0].target.value;
              if (item.includes(",") || item.includes(";")) {
                item = item.replaceAll(",", ";");

                const emails = item
                  .split(";")
                  .map((v) => v.trim())
                  .filter(Boolean)
                  .filter(isValidEmail);
                setValue((v) => {
                  const list = {};
                  [...v, ...emails].forEach((v) => {
                    list[v] = true;
                  });
                  return Object.keys(list);
                });
                const param0 = p[0];
                param0.target.value = "";
                params?.inputProps?.onChange?.(param0);
              } else {
                params?.inputProps?.onChange?.(...p);
              }
            },
            onBlur: (...p) => {
              if (isValidEmail(params.inputProps.value?.trim())) {
                setValue((v) => [...v, params.inputProps.value.trim()]);
                params?.inputProps?.onChange?.({
                  target: {
                    value: "",
                  },
                });
              }
              params.inputProps.value;
              params?.inputProps?.onBlur?.(...p);
            },
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: value?.length ? (
              <>
                <InputAdornment position="end">
                  <IconButton size="small" onClick={handleCopy} edge="end">
                    <ContentCopyIcon />
                  </IconButton>
                </InputAdornment>
                {params.InputProps.endAdornment}
              </>
            ) : null,
          }}
        />
      )}
    />
  );
}
